import { type ApiContainerAction, type EnumContainerOrderAction } from '@Model';
import { hasNoContainerType, toContainerActionGroups } from './containerActionGroups';
import { splitExchanges } from './plannedContainerEntries';

/** One line of an order's container actions in a list: what is done with how many containers of a type. */
export interface ContainerActionListLine {
    key: string;
    /** The container type's id, empty for a type the master data does not know yet. */
    typeId: string;
    label: string;
    action: EnumContainerOrderAction | 'swap';
    quantity: number;
}

/** The container actions of an order as lines by action and type, both halves of an exchange as one swap line. */
// @ai-generated 2026-11-03T07:49:46+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5
export function toContainerActionListLines(actions: readonly ApiContainerAction[]): ContainerActionListLine[] {
    const { exchanges, rest } = splitExchanges(actions);
    const lines = new Map<string, ContainerActionListLine>();
    const add = (action: ContainerActionListLine['action'], typeId: string, label: string, quantity: number) => {
        const key = `${action}:${typeId}`;
        const line = lines.get(key);
        if (line) {
            line.quantity += quantity;
            return;
        }

        lines.set(key, { key, typeId, label, action, quantity });
    };

    toContainerActionGroups(rest).forEach(({ action, id, label, quantity }) => add(action, id, label, quantity));
    exchanges
        .filter(({ pickup }) => !hasNoContainerType(pickup))
        .forEach(({ pickup }) =>
            add('swap', pickup.container_type.foreign_key ?? '', pickup.container_type.display_string, 1),
        );

    return [...lines.values()];
}
